import api from '../services/api';

/**
 * When axios reports a network failure, the cause is often either (1) CRA build
 * without REACT_APP_API_URL so requests hit the static host, or (2) CORS on Render.
 */
export function getApiConnectionErrorMessage() {
  const base = String(api.defaults.baseURL || '').trim();
  const relativeOnly =
    base === '/api' ||
    base === '' ||
    (base.startsWith('/') && !base.startsWith('//'));
  const h = typeof window !== 'undefined' ? window.location.hostname : '';
  const looksDeployed =
    h.endsWith('.vercel.app') ||
    h.endsWith('.netlify.app') ||
    (h !== 'localhost' && h !== '127.0.0.1');

  if (relativeOnly && looksDeployed) {
    return 'This build has no API URL. In Vercel set REACT_APP_API_URL to your Render https URL for Production, then redeploy.';
  }

  return (
    'Cannot reach the API. In DevTools → Network, open the failed request: confirm URL is your Render host (/api/…). ' +
    'Redeploy Render (latest backend) and Vercel. If the page URL is a Vercel preview (*.vercel.app), deploy backend with auto Vercel CORS or set CORS_ALLOW_VERCEL_APP=true on Render.'
  );
}
